import React from 'react';

export const Footer = () => {
    return (
        <footer className="py-12 border-t border-white/10 bg-black/20 backdrop-blur-xl text-center relative z-10">
            <div className="container mx-auto px-4">
                <h3 className="text-2xl font-bold text-white mb-2">Social SEO</h3>
                <p className="text-white/60 mb-8">Growth through strategy & execution</p>
                <p className="text-white/30 text-sm">©️ 2026 Social SEO. All rights reserved.</p>
            </div>
        </footer>
    );
};
